import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function RecruitmentView() {
  useDocumentTitle('Recruitment process-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-25'} title={'Recruitment Process'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="color-border mb-3"></div>
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">Our recruitment process</h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  To work with us, you will go through the following..
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/training">
                        Training
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/reward">
                        Reward and Recognition
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h3 className="white-color">Apply online</h3>
                <p className="white-color">
                  Apply online for one of our vacancies. A member of our
                  recruitment team will get in touch with you thereafter.
                </p>
                <h3 className="white-color">Telephone conversation</h3>
                <p className="white-color">
                  You will have a telephone screening with one of our
                  recruitment consultants who will assess your suitability for
                  the vacancies we have available. It will also give you an
                  opportunity to ask any questions about Quality Health and
                  Homecare Services and the role that you are applying for.
                </p>
                <h3 className="white-color">Interview</h3>
                <p className="white-color">
                  If you are successful in your telephone screening, you will
                  then be invited to a formal online interview with your local
                  office, giving you an opportunity to meet members of your
                  team.
                </p>
                <h3 className="white-color">Job offer</h3>
                <p className="white-color">
                  Generally, any job offers and feedback will be given within 48
                  hours following your interview. However, this can vary if we
                  are holding interviews across a few dates. We will let you
                  know when you can expect to hear from us.
                </p>
                <h3 className="white-color">Screening</h3>
                <p className="white-color">
                  When you accept our job offer, we will do a full screening
                  process through our compliance team to ensure you are ready
                  for work. The employment checks we carry out include enhanced
                  Criminal Records check (DBS), full work history, referencing,
                  health questionnaire ID and eligibility to work checks.
                </p>
                <h3 className="white-color">Training and compliance</h3>
                <p className="white-color">
                  After you accept our job offer, you will begin your training
                  and be taken through our compliance process to ensure you have
                  everything you need ready to start your first job with us. We
                  deliver personal and complex care services to our clients so
                  you will also get the opportunity to attend specialist
                  training where required.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default RecruitmentView;
